import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/framework/store'

// Discover modules
import modules from '@/framework/modules'

import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
// Helpers
import colors from 'vuetify/es5/util/colors'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    primary: colors.lightBlue.base,
    secondary: colors.lightBlue.darken4,
    accent: colors.grey.lighten1,
    error: colors.red.darken1,
    info: colors.lightBlue.lighten4,
    success: colors.lightGreen.base,
    warning: colors.amber.base
  }
})
Vue.use(Vuelidate)

// preinstall modules
modules.preinstall(Vue)

// if needed we can later install additional components later in the pipeline
modules.install(Vue)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
